import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import styles from './styles.module.scss';

export interface NavItem {
  to: string;
  labelKey: string;
  icon?: string;
  disabled?: boolean;
  disabledLabelKey?: string;
}

interface AdminNavProps {
  className?: string;
}

const adminNavItems: NavItem[] = [
  { to: '/admin/users', labelKey: 'users', icon: '👥' },
  { to: '/admin/bp-settings', labelKey: 'bpSettings', icon: '⚙️' },
  { to: '/admin/leagues', labelKey: 'leagues', icon: '⚽' },
  { to: '/admin/bookmakers', labelKey: 'bookmakers', icon: '📊' },
  { to: '/admin/league-bookmakers', labelKey: 'leagueBookmakers', icon: '🎯' },
  { to: '/admin/matches', labelKey: 'matchesAdmin', icon: '🔧' },
  { to: '/admin/debug-api', labelKey: 'debugApi', icon: '🐛' },
];

const AdminNav: React.FC<AdminNavProps> = ({ className }) => {
  const { t } = useTranslation('admin');
  const { t: tCommon } = useTranslation('common');

  return (
    <div className={classNames(styles.card, className)}>
      <h3 className={styles.title}>{t('adminPanel')}</h3>
      <nav className={styles.nav}>
        {adminNavItems.map((item) => (
          item.disabled ? (
            <div key={item.to} className={classNames(styles.navItem, styles.disabled)}>
              {item.icon && <span className={styles.icon}>{item.icon}</span>}
              <span className={styles.label}>{t(item.labelKey)}</span>
              {item.disabledLabelKey && (
                <span className={styles.badge}>{tCommon(item.disabledLabelKey)}</span>
              )}
            </div>
          ) : (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                classNames(styles.navItem, { [styles.active]: isActive })
              }
            >
              {item.icon && <span className={styles.icon}>{item.icon}</span>}
              <span className={styles.label}>{t(item.labelKey)}</span>
            </NavLink>
          )
        ))}
      </nav>
    </div>
  );
};

export default AdminNav;
